/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'isomorphic-fetch';

import moment from 'moment';

import Vue from 'vue';
import router from './router';
import store from './store';
import vuetify from '@/plugins/vuetify';
import { sync } from 'vuex-router-sync';

import App from './App.vue';
import ApiClient from './classes/api';
import AuthClient from './classes/auth';
import AuthJwtClient from './classes/authJwt';

Vue.config.productionTip = false;

import './plugins/i18n.js';
import './plugins/moment.js';
import './plugins/linkify.js';

sync(store, router);

Vue.use(ApiClient, { domain: `${window.location.protocol}//${window.location.host}/core/api` });
Vue.use(AuthClient, { domain: `${window.location.protocol}//${window.location.host}/auth/api` });
Vue.use(AuthJwtClient, { domain: `${window.location.protocol}//${window.location.host}/auth` });

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
